import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

import { Parser } from 'maf-web';
import { AppService } from './app.service';
import { ConsumidorSiteResponseGetConsumidorV0APP } from './vo/sitevo.vo';

@Component({
  selector: 'app-root',
  template: `
    <div class="container-app">

      <div *ngIf="isHeader" class="header-app">
        <div class="logo-header-app">
          <img (click)="inicio()" [src]="srcLogo" [title]="fantasia" [alt]="fantasia">
        </div>
        <div class="menu-header-app">
          <ul>
            <li>
              <div [ngClass]="{'novo-cadastro': isCadastro}" class="macle-tooltip">
                <i class="far fa-phone-square-alt"></i><br><span>SAC</span>
                <span [ngClass]="{'macle-tooltip-bottom-left': isVitrine}" class="macle-tooltip-text macle-tooltip-bottom">
                  {{formatarTelefone(telefone)}}
                </span>
              </div>
            </li>
            <li *ngIf="!isInicio && !isCadastro && !isVitrine">
              <div (click)="inicio()"><i class="far fa-home-lg-alt"></i><br><span>INÍCIO</span></div>
            </li>
            <li *ngIf="!isCadastro && !isVitrine">
              <div (click)="sair()"><i class="far fa-sign-out-alt"></i><br><span>SAIR</span></div>
            </li>
          </ul>
        </div>
      </div>

      <modal-confirmacao *ngIf="modalConfirmacao" [dataConfirmacao]="consumidorSiteResponse"></modal-confirmacao>

      <div class="content-app">
        <router-outlet></router-outlet>
      </div>
    </div>
  `,
  styleUrls: ['./app.css']
})
export class AppComponent implements OnInit {

  isHeader: boolean = false;
  isInicio: boolean = false;
  isCadastro: boolean = false;
  isVitrine: boolean = false;
  srcLogo: string = '';
  fantasia: string = '';
  telefone: string = '';

  constructor(
    private app: AppService,
    private titleService: Title,
    private router: Router
  ) {
    this.titleService.setTitle(this.app.lojaFantasia);
  }

  get modalConfirmacao(): boolean { return this.app.modalConfirmacao; }
  get consumidorSiteResponse(): ConsumidorSiteResponseGetConsumidorV0APP { return this.app.consumidorSiteResponse; }

  ngOnInit(): void {
    if (this.app.parametrosAPP == null || this.app.consCliente == null) {
      if (this.app.startURL != null && this.app.startURL.length > 0 && this.app.startURL[0].length > 0 && this.app.startURL[0] === 'vitrine') {
        const url = '/' + this.app.startURL.join('/');
        this.router.navigate([url]);
      } else {
        this.router.navigate(['/']);
      }
    }
    this.checkURL();
    this.router.events.subscribe(event => this.checkURL());
    this.srcLogo = this.app.lojaLogoBase64;
    this.fantasia = this.app.lojaFantasia;
    this.telefone = this.app.lojaTelefone;
  }

  formatarTelefone(numero: string): string {
    return Parser.formataFone(numero);
  }

  private checkURL() {
    this.isHeader = this.router.url !== '' && this.router.url !== '/login';
    this.isInicio = this.router.url === '/inicio';
    this.isCadastro = this.router.url === '/cadastro';
    this.isVitrine = this.router.url.indexOf('/vitrine') > -1 || this.router.url === '/';
  }

  inicio() {
    if (this.isCadastro) {
      this.router.navigate(['/login']);
    } else if (this.isVitrine) {
      // não faz nada
    } else {
      this.router.navigate(['/inicio']);
    }
  }

  sair() {
    this.app.logout();
    this.router.navigate(['/login']);
  }

}
